import type { IMaskFunction } from 'interfaces/IMask';

const number: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return '';

    const regexp = /^(\d{0,20}).*/;
    const result = '$1';

    return value
      .toString()
      .replace(regexp, result)
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '');
  },
  clean: (value: string): string | number => {
    if (!value) {
      return '';
    }
    return Number.parseInt(value.toString().replace(/\D/gi, '').substr(0, 20));
  },
};

export default number;
